import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Alert, Button, Form } from "react-bootstrap";
import UserService from "../services/user.service";

const EmailConfirm = () => {
  const [searchParams] = useSearchParams();
  const [message, setMessage] = useState("Die Bestätigung wird geprüft …");
  const [ok, setOk] = useState(false);
  const [email, setEmail] = useState("");
  const [resent, setResent] = useState("");

  useEffect(() => {
    const token = searchParams.get("token") || "";
    if (token.length < 32) {
      setOk(false);
      setMessage("Der Bestätigungslink ist unvollständig.");
      return;
    }
    UserService.confirmSelfServiceEmail(token)
      .then((response) => {
        setOk(true);
        setMessage((response.data && response.data.message) || "E-Mail-Adresse wurde bestätigt.");
      })
      .catch((error) => {
        const data = error && error.response ? error.response.data : null;
        setOk(false);
        setMessage((data && data.message) || "Die Bestätigung ist fehlgeschlagen.");
      });
  }, [searchParams]);

  const resend = async (event) => {
    event.preventDefault();
    setResent("");
    try {
      const response = await UserService.resendSelfServiceConfirmation(email);
      setResent((response.data && response.data.message) || "Bitte prüfen Sie Ihr Postfach.");
    } catch (error) {
      setResent("Der Link konnte nicht erneut angefordert werden.");
    }
  };

  return (
    <div className="container myn-signup">
      <h1 className="myn-signup__title">E-Mail-Adresse bestätigen</h1>
      <Alert variant={ok ? "success" : "warning"}>{message}</Alert>
      {ok && (
        <Button as={Link} to="/login">
          Zur Anmeldung
        </Button>
      )}
      {!ok && (
        <Form onSubmit={resend} className="mt-4">
          <Form.Group controlId="resendEmail">
            <Form.Label>Link erneut senden</Form.Label>
            <Form.Control
              type="email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              required
              autoComplete="email"
            />
          </Form.Group>
          <Button type="submit" className="mt-3">
            Erneut senden
          </Button>
          {resent && <p className="mt-3">{resent}</p>}
        </Form>
      )}
    </div>
  );
};

export default EmailConfirm;
